<template>
  <b-row class="macro-card h-100">
    <b-col class="data-col">
      <b-card class="section-col component-bg">
        <div class="h-100">
          <b-row class="h-100">
            <b-col class="diagnosis-content">
              <div class="h-100">
                <div class="py-2 section-content h-100">
                  <div class="section-global h-100 d-flex flex-column">
                    <b-row class="d-flex align-items-center mt-2 mb-3">
                      <b-col>
                        <span class="ap-title ap-title__main">{{ $t('diagnosis.btns.globalMacro') }}</span>
                      </b-col>
                      <b-col
                        cols="auto"
                        class="d-flex justify-content-end"
                      >
                        <div class="d-flex">
                          <vt-loading-button
                            qa="macros-of-case-export-button"
                            class="btn__icon btn__icon--primary px-2"
                            :params="{ promise: generateCaseMacrosReport }"
                          >
                            <i
                              v-tooltip="$t('global.export')"
                              class="far fa-file-export"
                              aria-hidden="true"
                            />
                          </vt-loading-button>
                        </div>
                      </b-col>
                    </b-row>
                    <div class="global-scroll-section p-2 flex-grow-1">
                      <b-row v-if="macroData.length">
                        <b-col>
                          <macro-card
                            v-for="(macro, index) in macroData"
                            :key="index"
                            :macro="macro"
                            @selectSampleFromMacro="$emit('selectSampleFromMacro', $event)"
                          />
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import MacroCard from '@/modules/diagnosisModule/views/form/macroView/MacroCard'
import sampleMacroService from '@/api/resources/description/SampleMacroService'
import diagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'

export default {
    name: 'MacrosOfCase',
    components: {
        MacroCard
    },
    props: {
        labId: { type: Number, required: true },
        casId: { type: Number, required: true },
        caseLabel: { type: String }
    },
    data() {
        return {
            macroData: []
        }
    },
    async created() {
        this.updateLoading(true)
        const [err, response] = await this.toCall(sampleMacroService.findAllByCaseId(this.labId, this.casId))
        this.updateLoading(false)
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.macroData = response
    },
    methods: {
        async generateCaseMacrosReport() {
            const blob = await this.$_toCallUnique(diagnosisCaseService.generateCaseMacrosReport(this.labId, this.casId))
            if (blob) {
                const openFileParams = {
                    blob,
                    newWindowTabTitle: `${this.caseLabel} - ${this.$tc('diagnosis.btns.globalMacro')}`
                }
                this.$_openFile(openFileParams)
            }
        }
    }
}
</script>

<style lang="scss">

.macro-card .section-col .card {
    height: auto !important;
}
.macro-card .global-scroll-section {
    overflow-y: auto;
    overflow-x: hidden;
}

</style>
